var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "div-block-102 noselect"
  }, [_c('div', {
    staticClass: "div-block-106"
  }, [_c('range-slider', {
    attrs: {
      "id-not-selected": 'not-selected-nadobudnutie',
      "id-selected": 'selected-nadobudnutie',
      "min": 0,
      "max": _vm.limit,
      "main-desc": 'nadobudnutie',
      "default-value": _vm.amounts.suma_nadobudnutie,
      "twoSideValues": false,
      "description": 'Výška úveru na',
      "unit": 'EUR',
      "value-correction": _vm.valueCorrection,
      "percentage-show": _vm.financedProperties.length !== 0 && _vm.foundedProperties.length !== 0,
      "percentage-max": _vm.financedPropertiesValue
    },
    on: {
      "value-corrected": function valueCorrected($event) {
        _vm.valueCorrection = null;
      },
      "change-event": function changeEvent($event) {
        return _vm.setNadobudnutieAmount($event, true);
      },
      "index-value-up-click": function indexValueUpClick($event) {
        return _vm.roundUpLtv($event);
      },
      "index-value-down-click": function indexValueDownClick($event) {
        return _vm.roundDownLtv($event);
      },
      "value-click": function valueClick($event) {
        return _vm.openMortgageAmountsEdit();
      }
    }
  })], 1), _vm._l(_vm.financedProperties, function (property, key) {
    return _c('div', {
      key: key,
      staticClass: "input-block contrast p-relative"
    }, [_c('div', {
      staticClass: "closebtn-broker-app pointer",
      on: {
        "click": function click($event) {
          return _vm.remove(property.id);
        }
      }
    }, [_c('img', {
      staticClass: "nav-link-icon extrasmall white",
      attrs: {
        "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f24_icons8-close.svg"
      }
    })]), _c('div', {
      staticClass: "closebtn-broker-app pointer edit",
      on: {
        "click": function click($event) {
          return _vm.finishProperty(property);
        }
      }
    }, [_c('img', {
      staticClass: "nav-link-icon extrasmall white",
      attrs: {
        "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/64cb50251cbbf5e263940bb6_edit%20icon%20simple.svg"
      }
    })]), _c('div', {
      staticClass: "div-block-101"
    }, [_vm._v(" " + _vm._s(_vm.getAddressModified(property)) + " "), property.loading ? _c('v-progress-circular', {
      staticClass: "loading-spinner extrasmall",
      attrs: {
        "indeterminate": ""
      }
    }) : _c('div', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(_vm._f("dotTheAmount")(property.hodnota)) + " EUR")])], 1)]);
  }), _c('client-property-handler', {
    attrs: {
      "rules": ['priority'],
      "type": 'financovane_nehnutelnosti',
      "title": '+ pridať financovanú NEHNUTEĽNOSŤ'
    }
  })], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }